import dayjs from 'dayjs';
import { DataModel } from '../dto/data-model.js';
import { BusinessModuleRef } from './business-module-ref.js';
import { Product } from './product.js';
import { CustomerProfile } from './customer-profile.js';

/**
 * @deprecated
 */
export abstract class LegacyTicketVoucher extends DataModel {
  abstract get uniqueId(): string;
  abstract get businessRef(): BusinessModuleRef;
  abstract get orderId(): string;
  abstract get promoCode(): string;
  abstract get creationDate(): dayjs.Dayjs;
  abstract get product(): Product;
  abstract get customer(): CustomerProfile;
}
